import * as React from "react"
import { cn } from "../../lib/utils"
const Card = React.forwardRef<
 HTMLDivElement,
 React.HTMLAttributes<HTMLDivElement> & { hoverable?: boolean }
>(({ className, hoverable, ...props }, ref) => (
 <div
 ref={ref}
 className={cn(
" rounded-xl border border-border-subtle bg-card text-card-foreground shadow-sm dark:shadow-card",
 hoverable &&"transition-shadow duration-200 hover:shadow-md dark:hover:border-border-strong",
 className
 )}
 {...props}
 />
))
Card.displayName ="Card"
const CardHeader = React.forwardRef<
 HTMLDivElement,
 React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
 <div
 ref={ref}
 className={cn("flex flex-col space-y-1.5 p-6", className)}
 {...props}
 />
))
CardHeader.displayName ="CardHeader"
const CardTitle = React.forwardRef<
 HTMLParagraphElement,
 React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
 // eslint-disable-next-line jsx-a11y/heading-has-content -- children via props
 <h3
 ref={ref}
 className={cn("text-lg font-semibold leading-none tracking-tight", className)}
 {...props}
 />
))
CardTitle.displayName ="CardTitle"
const CardDescription = React.forwardRef<
 HTMLParagraphElement,
 React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
 <p
 ref={ref}
 className={cn("text-sm text-muted-foreground", className)}
 {...props}
 />
))
CardDescription.displayName ="CardDescription"
const CardContent = React.forwardRef<
 HTMLDivElement,
 React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
 <div ref={ref} className={cn("p-6 pt-0", className)} {...props} />
))
CardContent.displayName ="CardContent"
const CardFooter = React.forwardRef<
 HTMLDivElement,
 React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
 <div
 ref={ref}
 className={cn("flex items-center p-6 pt-0", className)}
 {...props}
 />
))
CardFooter.displayName ="CardFooter"
export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent }
